// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAPVYJzUeiaew_r7FaKXa3mp1mq5Ao_oF8",
  authDomain: "grading-b1723.firebaseapp.com",
  projectId: "grading-b1723",
  storageBucket: "grading-b1723.appspot.com",
  messagingSenderId: "793279003905",
  appId: "1:793279003905:web:b7a94ecbce1a803c19af00",
  measurementId: "G-R51PBB84YQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);